export const shoppingCartRemove = (shoppingCartString: string, productId: string) => {
  const shoppingCart = JSON.parse(shoppingCartString);
  delete shoppingCart[productId];
  return JSON.stringify(shoppingCart);

}